import { useSelector } from 'react-redux';
import { selectUserId } from '~/user/selectors';
import { selectIsManagerInChannel } from '~/profile-sidebar/selectors';
import { PostEntity } from '../../PostEntity';

export const usePostPermissions = (post) => {
  const userId = useSelector(selectUserId);
  const postChannelId = PostEntity.getChannelId(post);

  const isManager = useSelector(selectIsManagerInChannel(postChannelId));
  const isPostOwner = PostEntity.userIsPostOwner(post, userId);

  const hasEditPermission = isManager || isPostOwner;
  const canEditPost = hasEditPermission && !PostEntity.isSent(post);

  return {
    isManager,
    isPostOwner,
    hasEditPermission,
    canEditPost,
  };
};
